import type { RedcatAnalyticsStore } from '../types/store';
import { OAuthTrackEventName } from '../types/oauth';
import type { OAuthErrorType, OAuthProvider } from '../types/oauth';
import type { OAuthTrackEvent } from '../types/events/track';

export const trackOAuthFlowFailed = (
  track: RedcatAnalyticsStore['track'],
  {
    provider,
    errorType,
    stageReached,
  }: { provider: OAuthProvider; errorType: OAuthErrorType; stageReached: string },
) => {
  const event: OAuthTrackEvent = {
    name: OAuthTrackEventName.FlowFailed,
    properties: {
      provider,
      error_type: errorType,
      stage_reached: stageReached,
    },
  };

  track(event);
};
